/**
 * `/sign-out` route — clears the Clerk session and redirects to `/` (RLY-013 AC #9).
 *
 * Why a route rather than a button-only action:
 *   - `/sign-out` lets a UI element (header link, deep-link from email, etc.)
 *     trigger logout without needing the click handler in scope.
 *   - The route is idempotent — visiting it while already signed out is a
 *     plain redirect to `/`.
 */

import { useClerk } from "@clerk/clerk-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export function SignOutPage() {
  const { signOut } = useClerk();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        await signOut();
      } finally {
        if (!cancelled) navigate("/", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [signOut, navigate]);

  return (
    <main
      aria-busy
      aria-label="Signing out"
      className="flex min-h-screen items-center justify-center bg-background p-8 text-muted-foreground"
    >
      Signing out…
    </main>
  );
}

export default SignOutPage;
